// extracted by mini-css-extract-plugin
export var cardSelected = "_ho-2";
export var image = "_ho-1";
export var table = "_ho-0";